import { HttpErrorResponse } from "@angular/common/http";
import { Component, Input, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Transactions } from "src/app/models/transactions.model";
import { PaymentService } from "src/app/services/payment.service";
import { SmsService } from "src/app/services/sms.service";

@Component({
  selector: "app-payment-receipt",
  templateUrl: "./payment-receipt.component.html",
  styleUrls: ["./payment-receipt.component.css"],
})
export class PaymentReceiptComponent implements OnInit {
  @Input() transaction!: Transactions;
  @Input() transferID!: string;

  public isLoading: boolean = false;
  public showPayButton: boolean = true;
  public canChangeTotal: boolean = false;
  public showSuccessMsg: boolean = false;

  public emailFormControl!: FormGroup;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private smsService: SmsService,
    private _matSnackbar: MatSnackBar,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    if (this.transaction.transactionStatus == 0) {
      // this.router.navigateByUrl(`px_transfer/${this.transferID}`);
    }
    this.emailFormControl = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
    });
  }

  checkComment() {
    return this.transaction.comment.trim();
  }
  onEmailSend() {
    if (this.emailFormControl.invalid || this.isLoading) return;

    this.isLoading = true;
    this.smsService
      .sendSMSEmailV2(
        this.transaction.hashOrderId,
        this.emailFormControl.get("email").value
      )
      .subscribe(
        (res) => {
          this.showSuccessMsg = true;
        },
        (err) => {
          // this.showSuccessMsg = true;

          this.translateService
            .get("transactions.emailerror")
            .subscribe((value) => {
              this._matSnackbar.open(value, "", { duration: 1500 });
              this.isLoading = false;
            });
        }
      );
  }
}
